import { matchPath, useLocation } from 'react-router-dom';

import { routes as appRoutes } from 'src/core/constants/routes';

export const useIsClosedDoorPath = () => {
  const location = useLocation();
  return Boolean(
    matchPath(location.pathname, {
      path: appRoutes.CLOSED_DOOR.path,
      exact: false,
      strict: false,
    }),
  );
};
